import React from 'react';
import {useWristbandPreview} from "../../../../hooks/api/wristbands/useWristbandPreview";

const PreviewButton = ({ wristband }) => {
    const { data: previewUrl, isLoading } = useWristbandPreview(wristband.id);

    return (
        <>
            {isLoading && <p>Loading...</p>}
            {previewUrl && <img src={`data:;base64,${previewUrl}`} className="w-100" alt="Preview" />}
        </>
  );
};

export default PreviewButton;
